import React, { Component } from 'react'

import classes from '../layout.css'
import { 
	ModuleOne, 
	ModuleTwo, 
	ModuleThree } from '../../../components/Modules'

class EndosseousImplants extends Component {
	render() {
		const { addToForm, consentForm } = this.props

		return (
			<form id={consentForm.formId} className={classes.Container}>
				<h2>{consentForm.formName}</h2>

				<ModuleOne 
					addToForm={addToForm} 
					consentForm={consentForm}
				/>
				<ModuleThree content={"placement of endosseous implants"}/>
				<ModuleTwo 
					addToForm={addToForm} 
					consentForm={consentForm}
				/>
			</form>
		)
	}
}

export default EndosseousImplants


// WEBPACK FOOTER //
// ./src/containers/FormLayout/Form/9.js